/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable sonarjs/prefer-immediate-return */
import { call, put, select } from 'redux-saga/effects';

import { AppState } from '@modules';

import { ReturnEffectType } from './types';

export function* getState() {
  const state: AppState = yield select();
  return state;
}

export function* callAsyncRequest<T>(fn: (...arg: any[]) => T, ...args: any[]) {
  const response: ReturnEffectType<typeof fn> = yield call(fn, ...args);
  return response;
}

export function* putRequest<T>(fn: (...arg: any[]) => T) {
  const response: Promise<ReturnEffectType<typeof fn>> = yield put(fn as any);
  return response;
}
